module.exports = __webpack_public_path__ + "img/geo_blue.e1f8ba9f.svg";